import React from 'react';

const UserDetailContext = React.createContext();

export default UserDetailContext;
